module.exports = __webpack_public_path__ + "static/media/figure2.dc2f36d2.png";